var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"contai"}},[_c('SideBare'),_c('ToolBare',{scopedSlots:_vm._u([{key:"cbody",fn:function(){return [_c('ProduitChips',{on:{"linkCliked":function($event){return _vm.makeLinke()}}})]},proxy:true}])}),_c(_vm.cmp,{tag:"component"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }